









import { Component, Vue } from "vue-property-decorator";
import DeliveryDestinationList from "@/components/cutomer/deliveryDestination/deliveryDestinationList.vue";
import QErrors from "@/common/qErrors.vue";

@Component({
  name: "DemoDeliveryDestinationList",
  components: {
    QErrors,
    DeliveryDestinationList,
  },
})
export default class DemoDeliveryDestinationList extends Vue {
  public mounted() {
    (this.$refs.DeliveryDestinationList as DeliveryDestinationList).showMe();
  }
  public deliverySelected(delivery) {
    console.log(delivery);
  }
}
